import { render, staticRenderFns } from "./svipConfirm.vue?vue&type=template&id=269a8518&scoped=true&lang=pug&"
import script from "./svipConfirm.vue?vue&type=script&lang=js&"
export * from "./svipConfirm.vue?vue&type=script&lang=js&"
import style0 from "./svipConfirm.vue?vue&type=style&index=0&id=269a8518&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "269a8518",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('269a8518')) {
      api.createRecord('269a8518', component.options)
    } else {
      api.reload('269a8518', component.options)
    }
    module.hot.accept("./svipConfirm.vue?vue&type=template&id=269a8518&scoped=true&lang=pug&", function () {
      api.rerender('269a8518', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/trade/vip/svipConfirm.vue"
export default component.exports